import { DateTimePicker, type DateTimePickerProps, Flex } from '@solinkcorp/solink-components';
import './EventTimePicker.sass';

interface EventTimePickerProps {
  dateTimePickerProps: DateTimePickerProps;
  minTime: number | Date | undefined;
  maxTime: number | Date | undefined;
  title: string;
  hideSeconds?: boolean;
}

export default function EventTimePicker(props: EventTimePickerProps) {
  const { dateTimePickerProps, minTime, maxTime, title, hideSeconds = false } = props;
  return (
    <Flex className="time-section" flexDirection="column" data-testid="time-end-section">
      <div className="time-section-title">{title}</div>
      <DateTimePicker
        {...dateTimePickerProps}
        name="date"
        stacked
        minTime={minTime}
        maxTime={maxTime}
        hideSeconds={hideSeconds}
      />
    </Flex>
  );
}
